module.exports = __webpack_public_path__ + "files/c637aceb2073352d5ef83401bc63bcec.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-144x144.png
// module id = 563
// module chunks = 60